import { Create, required, SimpleForm, TextInput } from 'react-admin'

const BannerCategoriesCreate = () => {
  return (
    <Create redirect={'/banner-categories'}>
        <SimpleForm>
            <TextInput source="name" fullWidth validate={[required()]} />
        </SimpleForm>
    </Create>
  )
}

export default BannerCategoriesCreate
